export default {
  de: {
    title: 'Gemeinden',
  },
};
